import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { addExpCategoryApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const addExpCategory = createAsyncThunk('addExpCategory', async (payload) => {
  return await addExpCategoryApi(payload);
});

const addExpCategorySlice = createSlice({
  name: 'addExpCategory', // Unique Name
  initialState,
  reducers: {
    addExpCategoryReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(addExpCategory.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(addExpCategory.fulfilled, (state, action) => {
        const { message = '', data = {}, payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(addExpCategory.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { addExpCategoryReset } = addExpCategorySlice.actions;

export default addExpCategorySlice.reducer;
